import { render } from "./PanelImportSettingsInfoDialog.vue?vue&type=template&id=a43a4498&ts=true"
import script from "./PanelImportSettingsInfoDialog.vue?vue&type=script&lang=ts"
export * from "./PanelImportSettingsInfoDialog.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__